import { r as e } from "./errors-BJxlOkXf.js";
//#region src/workflow/pageContext.ts
var t = [
	"contextType",
	"applicationCode",
	"processId",
	"processVersion",
	"definitionVersionNo",
	"processInstancePublicId",
	"workflowTaskPublicId",
	"businessTaskId",
	"businessObjectType",
	"businessObjectPublicId",
	"recipientType",
	"allowedActions",
	"baseFormPublicId"
], n = [
	"actionCode",
	"label",
	"requiresComment",
	"operationType",
	"formValidationPolicy"
], r = /* @__PURE__ */ new Set([
	"TODO",
	"DONE",
	"CC"
]), i = Object.freeze({
	SUBMIT: {
		operationType: "WORKFLOW",
		formValidationPolicy: "REQUIRED"
	},
	APPROVE: {
		operationType: "WORKFLOW",
		formValidationPolicy: "REQUIRED"
	},
	RETURN: {
		operationType: "WORKFLOW",
		formValidationPolicy: "SKIP"
	},
	RECALL: {
		operationType: "WORKFLOW",
		formValidationPolicy: "SKIP"
	},
	END: {
		operationType: "WORKFLOW",
		formValidationPolicy: "SKIP"
	},
	TRANSFER: {
		operationType: "WORKFLOW",
		formValidationPolicy: "SKIP"
	},
	SAVE: {
		operationType: "SHELL_LOCAL",
		formValidationPolicy: "SKIP"
	}
});
function a(e, a) {
	if (!s(e, t)) throw f();
	let o = e, l = u(o.applicationCode, 64);
	if (o.contextType !== "WORK_ITEM" || !l || a !== void 0 && l !== a || !c(o.processId, 128) || !Number.isInteger(o.processVersion) || Number(o.processVersion) < 1 || !Number.isInteger(o.definitionVersionNo) || Number(o.definitionVersionNo) < 1 || !d(o.processInstancePublicId) || !d(o.workflowTaskPublicId) || !c(o.businessTaskId, 128) || !c(o.businessObjectType, 100) || !c(o.businessObjectPublicId, 128) || !r.has(o.recipientType) || !d(o.baseFormPublicId) || !Array.isArray(o.allowedActions) || o.allowedActions.length > 8) throw f();
	let p = /* @__PURE__ */ new Set(), m = o.allowedActions.map((e) => {
		if (!s(e, n)) throw f();
		let t = e, r = u(t.actionCode, 160), a = i[r];
		if (!r || !a || p.has(r) || !c(t.label, 200) || typeof t.requiresComment != "boolean" || t.operationType !== a.operationType || t.formValidationPolicy !== a.formValidationPolicy) throw f();
		return p.add(r), Object.freeze({
			actionCode: r,
			label: t.label,
			requiresComment: t.requiresComment,
			operationType: t.operationType,
			formValidationPolicy: t.formValidationPolicy
		});
	});
	if (o.recipientType === "CC" && m.length !== 0) throw f();
	return Object.freeze({
		contextType: "WORK_ITEM",
		applicationCode: l,
		processId: o.processId,
		processVersion: o.processVersion,
		definitionVersionNo: o.definitionVersionNo,
		processInstancePublicId: o.processInstancePublicId,
		workflowTaskPublicId: o.workflowTaskPublicId,
		businessTaskId: o.businessTaskId,
		businessObjectType: o.businessObjectType,
		businessObjectPublicId: o.businessObjectPublicId,
		recipientType: o.recipientType,
		allowedActions: Object.freeze(m),
		baseFormPublicId: o.baseFormPublicId
	});
}
function o(e) {
	if (typeof e != "string" || e.length < 1 || e.length > 500 || !e.startsWith("/") || l(e) || /%25/i.test(e) || /%(?:2f|5c)/i.test(e)) return !1;
	try {
		return !l(decodeURIComponent(e));
	} catch {
		return !1;
	}
}
function s(e, t) {
	if (!e || typeof e != "object" || Array.isArray(e)) return !1;
	let n = Object.keys(e);
	return n.length === t.length && n.every((e) => t.includes(e));
}
function c(e, t) {
	return typeof e == "string" && e.length >= 1 && e.length <= t && e === e.trim() && !/[\r\n]/.test(e);
}
function l(e) {
	return e.includes("//") || e.includes("\\") || /[?#*{}]/.test(e) || [...e].some((e) => e.charCodeAt(0) < 32 || e.charCodeAt(0) === 127) || e.split("/").some((e) => e === "." || e === "..");
}
function u(e, t) {
	return typeof e == "string" && e.length <= t && /^[A-Z][A-Z0-9_]*$/.test(e) ? e : "";
}
function d(e) {
	return typeof e == "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(e);
}
function f() {
	return new e("SDK_WORKFLOW_CONTEXT_INVALID", "Workflow 工作项上下文不完整或不符合 SDK 契约");
}
//#endregion
//#region src/workflow/processInitiationViewContext.ts
var p = [
	"contextType",
	"applicationCode",
	"processId",
	"processVersion",
	"definitionVersionNo",
	"processInstancePublicId",
	"businessObjectType",
	"businessObjectPublicId",
	"startSnapshot"
], m = [
	"receiptPublicId",
	"sourceFormPublicId",
	"version",
	"schemaVersion",
	"hash",
	"data"
], h = /^[A-Z][A-Z0-9_]*$/, g = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
function _(e, t) {
	if (!b(e, p)) throw T();
	let n = e;
	if (n.contextType !== "PROCESS_INITIATION_VIEW" || !x(n.applicationCode, 64) || t !== void 0 && n.applicationCode !== t || !x(n.processId, 128) || !C(n.processVersion) || !C(n.definitionVersionNo) || !w(n.processInstancePublicId) || !S(n.businessObjectType, 100) || !S(n.businessObjectPublicId, 128) || !Object.hasOwn(n, "startSnapshot")) throw T();
	let r = null;
	if (n.startSnapshot !== null) {
		if (!b(n.startSnapshot, m)) throw T();
		let e = n.startSnapshot;
		if (!w(e.receiptPublicId) || !w(e.sourceFormPublicId) || typeof e.version != "string" || e.version.length === 0 || [...e.version].length > 64 || !S(e.schemaVersion, 32) || typeof e.hash != "string" || !/^[0-9a-f]{64}$/.test(e.hash) || !y(e.data)) throw T();
		let t = /* @__PURE__ */ new WeakSet(), i = v(e.data, 0, t);
		if (new TextEncoder().encode(JSON.stringify(i)).length > 1048576) throw T();
		r = Object.freeze({
			receiptPublicId: e.receiptPublicId,
			sourceFormPublicId: e.sourceFormPublicId,
			version: e.version,
			schemaVersion: e.schemaVersion,
			hash: e.hash,
			data: i
		});
	}
	return Object.freeze({
		contextType: "PROCESS_INITIATION_VIEW",
		applicationCode: n.applicationCode,
		processId: n.processId,
		processVersion: n.processVersion,
		definitionVersionNo: n.definitionVersionNo,
		processInstancePublicId: n.processInstancePublicId,
		businessObjectType: n.businessObjectType,
		businessObjectPublicId: n.businessObjectPublicId,
		startSnapshot: r
	});
}
function v(e, t, n) {
	if (t > 12) throw T();
	if (e === null || typeof e == "boolean" || typeof e == "string" && e.length <= 2e4 || typeof e == "number" && Number.isFinite(e)) return e;
	if (!e || typeof e != "object" || n.has(e)) throw T();
	if (n.add(e), Array.isArray(e)) {
		if (e.length > 1e4) throw T();
		let r = Object.freeze(Array.from(e, (e) => v(e, t + 1, n)));
		return n.delete(e), r;
	}
	if (!y(e) || Object.keys(e).length > 1e4) throw T();
	let r = Object.create(null);
	for (let [i, a] of Object.entries(e)) {
		if (!i.trim()) throw T();
		r[i] = v(a, t + 1, n);
	}
	return n.delete(e), Object.freeze(r);
}
function y(e) {
	return typeof e == "object" && !!e && !Array.isArray(e) && (Object.getPrototypeOf(e) === Object.prototype || Object.getPrototypeOf(e) === null);
}
function b(e, t) {
	return y(e) && Object.keys(e).length === t.length && Object.keys(e).every((e) => t.includes(e));
}
function x(e, t) {
	return typeof e == "string" && e.length <= t && h.test(e);
}
function S(e, t) {
	return typeof e == "string" && e.length > 0 && e.length <= t && e.trim() === e && !/[\r\n]/.test(e);
}
function C(e) {
	return typeof e == "number" && Number.isSafeInteger(e) && e > 0;
}
function w(e) {
	return typeof e == "string" && g.test(e);
}
function T() {
	return new e("SDK_WORKFLOW_CONTEXT_INVALID", "发起实例只读上下文不完整或不符合 SDK 契约");
}
//#endregion
export { o as n, a as r, _ as t };
